/**
 * Central role dictionary — single source of truth for role names.
 *
 * These values MUST match the realm-role names configured in Keycloak.
 * Import this map instead of hard-coding role strings in application logic.
 */
export const ROLES = {
  ADMIN: 'role_administrator',
  ACCOUNTANT: 'role_accountant',
  EDITOR: 'role_editor',
  MAINTENANCE: 'role_maintenance',
  SUPPORT: 'role_support_agent',
} as const;

/** Union of the human-readable key names (ADMIN, ACCOUNTANT, …) */
export type RoleKey = keyof typeof ROLES;

/** Union of the actual Keycloak realm-role values */
export type RoleValue = (typeof ROLES)[RoleKey];

/** All valid role values as an ordered array (for iteration / validation) */
export const ALL_ROLE_VALUES: readonly RoleValue[] = Object.values(ROLES);
